<template>
  <section pr-fill>
    <div pr-fill-body>
      <h3>{{ title }}</h3>
      <div class="cover">
        <div class="cover-clip" :style="clipStyle">
          <div class="cover-img" :style="imageStyle">
            <video v-if="video" :src="video" muted autoplay loop playsinline/>
            <h3>{{ title }}</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getOffsetTop } from '@/utils';
import responsive from '@/utils/responsive';

export default {
  name: 'PrFill',
  props: {
    title: {
      type: String,
      default: '',
    },
    video: { type: String },
    img: { type: String },
  },
  data() {
    return {
      imageStyle: {},
      clipStyle: {},
      fixed: false,
    };
  },
  watch: {
    sv: 'render',
  },
  methods: {
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      const d = getOffsetTop(this.$el) - sv;
      const h = window.innerHeight;
      if (d < -window.innerHeight * 2 || d > window.innerHeight * 2) return;
      const w = window.innerWidth;
      let cw;
      if (d > h * 0.6) {
        // cw = 0;
      } else if (d < h * 0.3) {
        cw = w;
      } else {
        cw = w * (h * 0.6 - d) / (h * 0.3);
      }
      this.clipStyle = { width: cw + 'px' };
      this.imageStyle = { width: w + 'px' };
      if (this.img) this.imageStyle.backgroundImage = `url(${this.img})`;
    }
  },
  mounted() {
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-fill-body] { .extra-bold; .h(330);
  h3 { .calibre; .fs(48); .semi-bold; .tc; .t(50%); .rel; transform: translateY(-50%); }
  .cover { z-index: 1; .abs; .wf; .hf; .lt;
    .cover-clip { .abs; overflow: hidden; .hf;
      .cover-img { .wf; .abs; color: #fff; .-box; .hf; .bg-c; .cover;
        video { .abs; .lt(50%,50%); .min-h(100%); .min-w(100%); transform: translate(-50%,-50%);}
        h3 { color:#fff;}
      }
    }
  }
}
@media (min-width: @screen-md-min) {
  [pr-fill-body] { .h(370);
    h3 { .fs(64); }
  }
}
@media (min-width: @screen-lg-min) {
  [pr-fill-body] {
    h3 { .fs(72); .-box; .pl(50%); }
  }
}
@media (min-width: @screen-xl-min) {
  [pr-fill-body] { .h(580);
    h3 { .fs(120); }
  }
}
</style>
